// The directors an Employee or External Advisor is waiting on, and how the waiting
// cards name them.
//
// The roster comes from user-management, which owns the reading of it: several
// producers write director records into business_details in several record shapes
// across several lists, and DirectorRosterReader is where every rule for reading
// that lives. So this file holds no shape handling. It takes the list the
// director-roster endpoint returns and puts it in the form the cards render.
//
// Each record carries firstName, middleName, lastName, fullName, email and
// shareholder. fullName is every part of the name in display order, and email is
// empty for a director sourced from the company register, which holds names and no
// addresses.

// The cards need a name and, where one is on record, an address. A record with no
// name is a row that names nobody, and an unnamed card is better than a wrong one,
// so it is left out.
export const selectWaitingDirectors = (roster) =>
  (Array.isArray(roster) ? roster : [])
    .map((director) => ({
      name: (director?.fullName || "").trim(),
      email: (director?.email || "").trim()
    }))
    .filter((director) => director.name);

export const directorNames = (directors) =>
  (Array.isArray(directors) ? directors : [])
    .map((director) => director?.name)
    .filter(Boolean)
    .join(", ");

export const directorContacts = (directors) =>
  (Array.isArray(directors) ? directors : [])
    .filter((director) => director?.name)
    .map((director) =>
      director.email ? `${director.name} (${director.email})` : director.name
    )
    .join(", ");
